// extracted by mini-css-extract-plugin
export default {"menuBlock":"DI-z","title":"EI-z","nav":"FI-z","flexCell":"GI-z","facetLink":"HI-z"};